import React, { Component } from 'react';
import Sidebar from '../sideBar';
import StatusSideBar from '../myCourse/statusSideBar';

const DefaultLayoutHOC = (WrappedComponent) => {
	return class extends Component {
		render() {
			const { showStatusSideBar, hideSidebar } = this.props;
			return (
				<>
					<section className="step-container align-stretch container">
						{!hideSidebar &&
							window.outerWidth > 768 &&
							localStorage.getItem('paymentInProcess') !== '1' && <Sidebar />}
						<div className="page-right-section">
							<div className="dashboard-page ">
								<div className="db-body ">
									<WrappedComponent {...this.props} />
								</div>
								{showStatusSideBar && <StatusSideBar />}
							</div>
						</div>
					</section>
				</>
			);
		}
	};
};

export default DefaultLayoutHOC;
